// JS DOSYASININ EN ÜSTÜNE YAPIŞTIRIN!

// Global değişkeni fonksiyonların erişimi için tutuyoruz
window.currentPopupButton = null;

// ANA TETİKLEME FONKSİYONU (Liquid'den direkt çağrılacak)
window.handleAddToCartPopup = function(btnElement) {
    
    // Pop-up elemanlarını bul
    const freightModal = document.getElementById("custom-popup-modal");
    const installModal = document.getElementById("custom-install-modal");

    // PDP'den gelen global değişkeni kontrol et
    const PDP_REQUIRED = window.REQUIRED_POPUP;

    const needInstall = btnElement.getAttribute("data-require-popup-install") === "true" || (PDP_REQUIRED === 'install');
    const needFreight = btnElement.getAttribute("data-require-popup-transport") === "true" || (PDP_REQUIRED === 'freight');

    if (!needInstall && !needFreight) {
         return true; // Pop-up gerekmiyorsa, normal form submit'ine izin ver (true döndür)
    }

    // Butonu global değişkene kaydet (Submit fonksiyonları için)
    window.currentPopupButton = btnElement;

    if (needFreight && freightModal) {
        freightModal.style.setProperty("display", "block", "important");
    }

    if (needInstall && installModal) {
        installModal.style.setProperty("display", "block", "important");
    }
    
    return false; // Pop-up açıldı, form submit'ini engelle (false döndür)
};


// --- İKİNCİL KISIM: DOMContentLoaded İÇİNDE SADECE SUBMİT VE KAPATMA MANTIKLARI ---
document.addEventListener("DOMContentLoaded", function () {

    // --- POPUP ELEMENTLERİ (Sadece DOMContentLoaded içinde gerekirse) ---
    const freightModal = document.getElementById("custom-popup-modal");
    const installModal = document.getElementById("custom-install-modal");

    const freightForm = document.getElementById("popup-question-form");
    const installForm = document.getElementById("popup-install-form");

    const closeFreight = document.querySelector(".close-button");
    const closeInstall = document.querySelector(".close-button-install");

    

    // NOT: Tıklama yakalama mantığı (document.addEventListener('click')) KALDIRILDI, 
    // yerine 'handleAddToCartPopup' fonksiyonu Liquid'den çağrılacak.

    // --- KAPATMA BUTONLARI ---
    if (closeFreight) closeFreight.addEventListener("click", () => freightModal.style.display = "none");
    if (closeInstall) closeInstall.addEventListener("click", () => installModal.style.display = "none");

    window.addEventListener("click", function (e) {
        if (e.target === freightModal) freightModal.style.display = "none";
        if (e.target === installModal) installModal.style.display = "none";
    });

    // --- FREIGHT SUBMIT (MANTIK AYNI) ---
    if (freightForm) {
        freightForm.addEventListener("submit", function (e) {
            e.preventDefault();

           const phoneInput = document.getElementById("freight-phone");
             const validationRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;


        if (!phoneInput || phoneInput.value.trim() === "") {
            alert("Please enter your phone number.");
            return;
        }

        // 3. REGEX İLE DOĞRULAMA (VALIDATION)
        // Eğer giriş, formatlardan HİÇBİRİNE uymuyorsa hata ver.
        if (!validationRegex.test(phoneInput.value.trim())) {
             alert("Please enter a valid phone number format (e.g., (555) 555-1234 or 555-555-1234).");
             return; // Gönderimi durdur
        }
            const selected = freightForm.querySelectorAll("input[type='radio']:checked");
            if (selected.length < 2) {
                alert("Please select all required options.");
                return;
            }

            // Global değişkenden ID al
            if (!window.currentPopupButton) return;
            const mainVariantId = window.currentPopupButton.getAttribute("data-variant-id");
            
            // ... (Kalan Freight Mantığı: Form oluşturma ve submit) ...
            const form = document.createElement("form");
            form.method = "POST";
            form.action = "/cart/add";

            const idInput = document.createElement("input");
            idInput.type = "hidden";
            idInput.name = "id";
            idInput.value = mainVariantId;
            form.appendChild(idInput);

            selected.forEach(opt => {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = opt.name;
                input.value = opt.value;
                form.appendChild(input);
            });
const phoneHiddenInput = document.createElement("input");
        phoneHiddenInput.type = "hidden";
        phoneHiddenInput.name = phoneInput.name; 
        phoneHiddenInput.value = phoneInput.value.trim();
        form.appendChild(phoneHiddenInput);

            document.body.appendChild(form);
            freightModal.style.display = "none";
            form.submit();
        });
    }

    // --- INSTALLATION SUBMIT (MANTIK AYNI) ---
    if (installForm) {
        installForm.addEventListener("submit", async function (e) {
            e.preventDefault();
            
            const selected = installForm.querySelector("input[name='properties[Installation Type]']:checked");
            if (!selected) {
                alert("Please select an installation option.");
                return;
            }

            // Global değişkenden ID ve handle al
            if (!window.currentPopupButton) return;
            const installationVariantId = selected.dataset.variantId;
            const mainVariantId = window.currentPopupButton.getAttribute("data-variant-id");
            const productHandle = window.currentPopupButton.getAttribute("data-product-handle");

            if (!mainVariantId) {
                alert("Main product ID missing!");
                return;
            }

            // ... (AJAX ile sepeti güncelleme mantığı) ...
            
            // Kurulum gerekmiyorsa (Sadece Ana Ürünü Ekle)
            if (!installationVariantId) {
                await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: mainVariantId, quantity: 1 }) });
                installModal.style.display = "none";
                window.location.href = "/cart";
                return;
            }

            // Eski installation ürününü sil ve yenilerini ekle (AJAX)
            const cart = await fetch("/cart.js").then(r => r.json());
            for (const item of cart.items) {
                if (item.properties && item.properties["Installation Type"] && item.handle === productHandle) {
                    await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ line: item.key, quantity: 0 }) });
                }
            }

            // Yeni installation + ana ürün ekle
            const itemsToAdd = [{ id: mainVariantId, quantity: 1, properties: { "Installation Type": selected.value}}, { id: installationVariantId, quantity: 1 }];
            await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: itemsToAdd }) });

            installModal.style.display = "none";
            window.location.href = "/cart";
        });
    }
});